export * from "./constant-campaign";

export const GET_LIST_BLOG = "GET_LIST_BLOG";
export const GET_LIST_BLOG_RESULT = "GET_LIST_BLOG_RESULT";
export const RESET_CHANGE_STATUS_APP_RESULT = "RESET_CHANGE_STATUS_APP_RESULT";
export const CHANGE_APP_STATUS = "CHANGE_APP_STATUS";
export const CHANGE_APP_STATUS_RESULT = "CHANGE_APP_STATUS_RESULT";
export const CHANGE_THEME = "CHANGE_THEME";

export const NOTIFICATION_TIME_CHANGE_ORDER = "NOTIFICATION_TIME_CHANGE_ORDER";
export const DESKTOP_POSITION_CHANGE = "DESKTOP_POSITION_CHANGE";
export const DISPLAY_TIME_CHANGE = "DISPLAY_TIME_CHANGE";
export const DELAY_BETWEEN_NOTIFICATION_CHANGE =
  "DELAY_BETWEEN_NOTIFICATION_CHANGE";

export const CART_TITLE_ON_CHANGE = "CART_TITLE_ON_CHANGE";

export const UPDATE_LANGUAGE = "UPDATE_LANGUAGE";
export const GET_LANGUAGE_PACKAGE = "GET_LANGUAGE_PACKAGE";
export const RECEIVED_CUSTOM_LANGUAGE = "RECEIVED_CUSTOM_LANGUAGE";
export const RECEIVED_LANGUAGE_PACKAGE = "RECEIVED_LANGUAGE_PACKAGE";
export const UPDATE_LANGUAGE_FIELD = "UPDATE_LANGUAGE_FIELD";
export const UPDATE_LANGUAGE_PACKAGE = "UPDATE_LANGUAGE_PACKAGE";
export const SAVE_LANGUAGE = "SAVE_LANGUAGE";
export const SAVE_LANGUAGE_RESULT = "SAVE_LANGUAGE_RESULT";

export const CHANGE_WELCOME = "CHANGE_WELCOME";
export const MOTIVATE_BANNER_UPDATE = "MOTIVATE_BANNER_UPDATE";

export const UPGRADE_PALN_PACKAGE = "UPGRADE_PALN_PACKAGE";
export const DOWNGRADE_PALN_PACKAGE = "DOWNGRADE_PALN_PACKAGE";

export const GET_LIST_NOTIFICATION = "GET_LIST_NOTIFICATION";
export const GET_LIST_NOTIFICATION_RESULT = "GET_LIST_NOTIFICATION_RESULT";
export const GET_NOTIFICATION_DETAIL = "GET_NOTIFICATION_DETAIL";
export const UPDATE_NOTIFICATION = "UPDATE_NOTIFICATION";
export const UPDATE_NOTIFICATION_RESULT = "UPDATE_NOTIFICATION_RESULT";
export const GET_NOTIFICATION_DETAIL_RESULT = "GET_NOTIFICATION_DETAIL_RESULT";
